"use strict";

angular.module("core")
.service("BrandSiteService", function($rootScope, $http, appConfig) {
    this.init = function() {
        $http.get(appConfig.API_SERVER + "/brand/current/", {
            withCredentials: false,
            disableTokenForRequest: true
        }).then(function(response) {
            if (response.data) {
                $rootScope.brandSite = response.data;
            }
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/brand-site/brand-site.service.js
// module id = 412
// module chunks = 0